"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { ArrowRight, Zap, Triangle } from "lucide-react";
import { EcommerceProductsProvider, useEcommerceProducts, AddToCartButton } from "@/integrations/wordpress/WordPressEcommerceProductsProvider";
import { WP_Query } from "@/integrations/wordpress/wp_query";
const wp_query_params = {
  post_type: "product",
  per_page: 3,
  search: "grandstream"
};
const wp_query = new WP_Query(wp_query_params);
function PeptidesProductGrid() {
  const {
    products,
    loading,
    error
  } = useEcommerceProducts();
  if (loading) {
    return <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6 mt-8">
        {[...Array(3)].map((_, i) => <div key={i} data-index={i} className="h-64 rounded-lg bg-primary/5 animate-pulse border border-primary/10" />)}
      </div>;
  }
  if (error || products.length === 0) {
    return null;
  }
  return <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6 mt-8 relative z-10">
      {products.map((product, i) => <div key={product.id} data-index={i} className="bg-white border border-border rounded-lg p-5 md:p-6 flex relative overflow-hidden group hover:shadow-xl transition-all duration-300">
          {}
          <div className="flex-1 z-10 flex flex-col pr-4">
            <h3 className="text-lg md:text-xl font-bold text-primary font-default mb-1 leading-tight">
              {product.title}
            </h3>

            <p className="text-[11px] md:text-xs text-foreground/60 mb-4 uppercase tracking-wider line-clamp-2">
              Hardware Empresarial
            </p>

            {}
            <div className="text-[10px] md:text-[11px] text-foreground/80 space-y-2 mb-6 flex-1">
              {product.short_description ? <div dangerouslySetInnerHTML={{
            __html: product.short_description
          }} className="[&>p]:mb-1 [&>ul]:space-y-1.5 [&_li]:flex [&_li]:items-start [&_li]:gap-1.5 [&_li_svg]:shrink-0 [&_li_svg]:mt-0.5 line-clamp-4" /> : <>
                  <div className="flex items-center gap-1.5 font-medium">
                    <Zap className="size-3 text-primary/50 shrink-0" />
                    <span>VOZ HD</span>
                  </div>
                  <div className="flex items-center gap-1.5 font-medium">
                    <Zap className="size-3 text-primary/50 shrink-0" />
                    <span>SEGURIDAD TLS</span>
                  </div>
                  <div className="flex items-center gap-1.5 font-medium">
                    <Zap className="size-3 text-primary/50 shrink-0" />
                    <span>GESTIÓN CLOUD</span>
                  </div>
                </>}
            </div>

            {}
            <div className="mt-auto">
            <Button variant="outline" className="border-primary/30 text-primary hover:bg-primary hover:text-white rounded-md text-xs h-8 px-4 bg-transparent transition-colors w-fit font-bold" onClick={() => window.location.href = product.link}>

    Ver detalles →

          </Button>
			</div>
          </div>

          {}
          <div className="w-20 md:w-24 shrink-0 relative z-0 flex items-end justify-center pb-2">
            {product.featured_image_url && <img src={product.featured_image_url} alt={product.title} className="max-w-full h-auto object-contain drop-shadow-lg transition-transform duration-500 group-hover:scale-105" loading="lazy" />}
            <div className="absolute bottom-4 left-1/2 -translate-x-1/2 w-16 h-16 bg-primary/10 blur-2xl rounded-lg -z-10" />
          </div>
        </div>)}
    </div>;
}
export default function TecnologAGrandstream() {
  return <section data-section-id="264132" id="tecnología-grandstream" className="w-full bg-background text-foreground ![padding:96px_0px_40px_0px]">
      <div className="page-container">
        {}
        <div className="bg-accent text-foreground rounded-lg relative overflow-hidden shadow-md border border-border !p-[30px]">
          {}
          <div className="absolute inset-0 opacity-20 pointer-events-none">
            <div className="absolute top-10 left-10 w-2 h-2 bg-primary rounded-lg blur-sm" />
            <div className="absolute top-40 right-20 w-1.5 h-1.5 bg-secondary rounded-lg blur-sm" />
            <div className="absolute bottom-20 left-1/3 w-2.5 h-2.5 bg-primary rounded-lg blur-md" />
            <div className="absolute top-1/2 right-1/4 w-1 h-1 bg-secondary rounded-lg" />
          </div>

          {}
          <div className="flex flex-col lg:flex-row justify-between items-start lg:items-end gap-8 relative z-10">
            <div className="max-w-2xl">
              <div className="flex items-center gap-2 text-xs md:text-sm font-bold tracking-widest uppercase mb-4 text-primary">
                <Triangle className="size-4 fill-primary text-primary rotate-90" />
                AVTEC | HARDWARE
              </div>
              <h3 className="text-4xl md:text-5xl lg:text-6xl font-bold font-default mb-3 leading-tight text-foreground">
                CONECTIVIDAD SIN LÍMITES.
              </h3>
              <p className="text-xs md:text-sm tracking-wider uppercase text-foreground/70 font-medium">
                Tecnología Grandstream - Potencia tu comunicación empresarial.
              </p>
            </div>

            <Button asChild className="bg-primary text-white hover:bg-primary/90 rounded-md px-6 shrink-0 font-bold shadow-sm">
              <Link to="/GrandstreamCentralPage">
                Ver Soluciones <ArrowRight className="ml-2 size-4" />
              </Link>
            </Button>
          </div>

          {}
          <EcommerceProductsProvider wp_query={{
          post_type: "product",
          per_page: 3,
          search: "grandstream"
        }}>
            <PeptidesProductGrid />
          </EcommerceProductsProvider>
        </div>
      </div>
    </section>;
}